<aside class="widget-area" id="secondary">
  <section
    class="widget widget_karlson_posts_thumb"
    style="
      background-size: 100px;
      padding: 20px;
      padding-top: 0;
      border: 1px solid #eeeeee;
      background: #fff;
    "
  >
    <div class="page-title-content" style="margin-top: 0; text-align: left">
      <ul>
        <li>
          <a routerLink="/">
            <i class="fa-solid fa-house"></i>
          </a>
        </li>
        <li>Governing Body</li>
      </ul>
    </div>
  </section>

  <!-- <section
    class="widget widget_karlson_posts_thumb"
    style="
      background-size: 100px;
      padding: 20px;
      border: 1px solid #eeeeee;
      margin-top: 15px;
      background: #fff;
    "
  >
    <h3 class="widget-title">Suggested Video</h3>

    <iframe
      width=100%
      height="215"
      src=""
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </section> -->

  <section
    class="widget widget_categories"
    style="
      background-size: 100px;
      padding: 20px;
      border: 1px solid #eeeeee;
      margin-top: 15px;
      background: #fff;
    "
  >
    <h3 class="widget-title">Related Topics</h3>

    <ul>
      <li>
        <a href='administration/governing-body'>Governing Body</a>
      </li>
       <li>
        <a href='administration/message-of-chairman'>Message Of Chairman</a>
      </li>
      <li>
        <a href='administration/message-of-principal'>Message Of Principal</a>
      </li>
    </ul>
  </section>
</aside>
